"use strict";

const developmentConfig = {
  NAME: "AAUTI SOCIAL CORE DEVELOPMENT",
  ENV: "development",
  SOCIAL_API_URL: "YOUR_SOCIAL_API_URL",
  SOCIAL_TENANT_ID: "YOUR_SOCIAL_TENANT_ID"
};
export default developmentConfig;
//# sourceMappingURL=development.js.map